import { Clock } from "lucide-react";

const BrokerSync = () => {
  const supportedBrokers = [
    "MetaTrader 4",
    "ThinkOrSwim",
    "TradeStation",
    "Interactive Brokers",
    "NinjaTrader",
  ];

  return (
    <div className="broker-sync-container">
      <div className="coming-soon-content">
        <div className="coming-soon-header">
          <Clock size={48} className="coming-soon-icon" />
          <h2>Broker Sync Coming Soon</h2>
        </div>

        <p className="coming-soon-description">
          We're working hard to bring you direct broker integration. This
          feature will allow you to automatically import your trades from your
          favorite brokers.
        </p>

        <div className="supported-brokers">
          <h3>Planned Support for:</h3>
          <ul className="broker-list">
            {supportedBrokers.map((broker, index) => (
              <li key={index} className="broker-item">
                <span className="checkmark">✓</span>
                {broker}
              </li>
            ))}
          </ul>
        </div>

        <div className="features-preview">
          <h3>Upcoming Features:</h3>
          <div className="feature-grid">
            <div className="feature-item">
              <h4>Real-Time Sync</h4>
              <p>Automatically import trades as they happen</p>
            </div>
            <div className="feature-item">
              <h4>Historical Data</h4>
              <p>Import your complete trading history</p>
            </div>
            <div className="feature-item">
              <h4>Multi-Account Support</h4>
              <p>Connect and manage multiple trading accounts</p>
            </div>
            <div className="feature-item">
              <h4>Custom Mapping</h4>
              <p>Map broker data to your preferred format</p>
            </div>
          </div>
        </div>

        <div className="notification-signup">
          <p>Want to know when this feature is ready?</p>
          <button className="notify-button">Get Notified</button>
        </div>

        <div className="alternative-message">
          <p>In the meantime, you can:</p>
          <ul>
            <li>Use our CSV import feature for bulk imports</li>
            <li>Manually input individual trades</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default BrokerSync;
